export const selectAllAlerts = (state) => state.alerts.allAlerts;
export const selectAllAlertsLoading = (state) => state.alerts.allAlertsLoading;
export const selectMenuAlerts = (state) => state.alerts.menuAlerts;
